import Vue from "vue";
import { API_ROOT } from "../config";
import {
  AuthResource,
  SignUpResource,
  ActivateAccountResource,
  MySelfResource,
  SupportSessionCreateResource,
  SupportSessionExchangeResource,
  SupportSessionEndResource,
  SyncRevisionsResource,
  ForgotPasswordResource,
  ResetPasswordResource,
  DeviceResource,
  DeviceOnlyResource,
  DeviceAllResource,
  DeviceSuspiciousAnalysisResource,
  DeviceSuspiciousEventsResource,
  DeviceTestResetPreviewResource,
  DeviceTestResetExecuteResource,
  DeviceLocationUpdateResource,
  DeviceActivateDryRunResource,
  DeviceMigrateResource,
  DevicePrepareDirectMqttResource,
  DeviceConfigUpdateResource,
  SolartrackerCanDisplayResource,
  DeviceSetreducedCommandsResource,
  DeviceUpdateResource,
  DeviceDeleteResource,
  DeviceEventResource,
  DeviceGetDebugValuesResource,
  //MQTTSetHTResource,
  //MQTTSetNTResource,
  //MQTTallAwakeResource,
  MQTTdeviceConsoleResource,
  MQTTbrokerAccessOverviewResource,
  MQTTbrokerAccessDeviceResource,
  MQTTfirmwareChecksumResource,
  MQTTPermissionRequestResource,
  MQTTPermissionRequestActionResource,
  MQTTPermissionDeviceActionResource,
  MQTTClaimRequestResource,
  MQTTClaimRequestActionResource,
  MQTTrescueOtaResource,
  MQTTotaNextionResource,
  MQTTrescueProvisionResource,
  MQTTdeviceConsoleStreamCloseResource,
  MQTTsetDeviceResource,
  GatewayConfigurationResource,
  GatewayRetryResource,
  RelayBoardConfigurationResource,
  ModbusGatewayConfigReadResource,
  ModbusGatewayConfigResource,
  ModbusGatewayTransactionResource,
  CreatePersonResource,
  PersonResource,
  PersonDeleteResource,
  PersonUpdateResource,
  PersonDeactivateResource,
  PersonHistoryResource,
  LocationResource,
  LocationCreateResource,
  LocationUpdateResource,
  LocationDeleteResource,
  LocationSecretRevealResource,
  LocationSecretSetResource,
  HeatcontrolMultiPreviewResource,
  HeatcontrolApartmentSupplyResource,
  HeatcontrolApartmentConsumptionResource,
  HeatcontrolApartmentDeviceResource,
  HeatcontrolTemperatureControlResource,
  HeatcontrolMultiCommitResource,
  HeatcontrolMultiActivateResource,
  HeatcontrolAreaBindingsResource,
  HeatcontrolMultiResource,
  HeatcontrolMultiDiagnosticsResource,
  HeatcontrolLocalTestResource,
  HeatcontrolMultiStageResource,
  HeatcontrolTransferCancelResource,
  HeatcontrolMultiRollbackResource,
  UserReadResource,
  UserResource,
  UserUpdateDashboardSettingsResource,
  CreateEnergyUnitResource,
  EnergyUnitResource,
  EnergyUnitDeleteResource,
  EnergyUnitUpdateResource,
  EnergyUnitDeactivateResource,
  EnergyUnitHistoryResource,
  GlobalResource,
  GlobalAllResource,
  GlobalUnusedResource,
  GlobalCreateResource,
  GlobalUpdateResource,
  GlobalDeleteResource,
  PriceIndexResource,
  CreatePriceIndexResource,
  PriceIndexUpdateResource,
  CreateContractResource,
  ContractResource,
  ContractDeleteResource,
  ContractUpdateResource,
  ContractDeactivateResource,
  ContractHistoryResource,
  EventallResetLocationResource,
  InvoiceResource,
  InvoiceDeleteResource,
  InvoiceProviderResource,
  InvoiceCreateProviderResource,
  InvoiceSendResource,
  InvoiceSendProviderAllResource,
  DeviceSettingResource,
  DeviceSettingCreateResource,
  DeviceSettingUpdateResource,
  DeviceGetResource,
  DeviceGetIFrameResource,
  LocationEventIndexResource,
  LocationRawEventIndexResource,
  UserCreateResource,
  UserUpdateResource,
  LocationPVForeCastResource,
  HaSolarForeCastResource,
  MixPriceForeCastResource,
  MpcControlHistoryResource,
  MpcCostOverviewResource,
  ObsDatasetResource,
  AlertResource,
  AlertDeleteResource,
  VapidPublicKeyResource,
  PushSubscriptionResource,
  PushUnsubscribeResource,
  IconResource,
  IconCreateResource,
  IconUpdateResource,
  IconDeleteResource,
  InverterParamsResource,
  InverterControlResource,
  AgentConnectionsResource,
  AgentConnectionResource,
  AgentConnectionTestResource,
  AgentConnectionVisionTestResource,
  AgentConnectionSetActiveResource,
  PlanImportSessionsResource,
  PlanImportPackageImportResource,
  PlanImportPackageExportResource,
  PlanImportSessionResource,
  PlanImportSessionArchiveResource,
  PlanImportFileResource,
  PlanImportExternalResource,
  PlanImportAnalyzeResource,
  PlanImportManualAnalysisResource,
  PlanImportReanalyzeResource,
  PlanImportChatResource,
  PlanImportPatchResource,
  PlanImportPatchUndoResource,
  PlanImportJobsResource,
  PlanImportJobCancelResource,
  PlanImportPreviewResource,
  PlanImportCommitResource,
  PlanImportRollbackPreviewResource,
  PlanImportRollbackResource,
  PlanImportReopenResource,
  PlanImportThermalProfilesResource,
  PlanImportGoogleContextResource,
  PlanImportAddressSearchResource,
  PlanImportObstacleHeightResource,
  PlanImportSunPathResource,
  PlanImportProcessProfileResource,
  ElasticConnectionsResource,
  ElasticConnectionResource,
  ElasticConnectionTestResource,
  ElasticConnectionSetActiveResource,

} from "./resources";

function isMethodNotAllowedError(err) {
  const status = err && err.status
  const message = String(
    (err && err.body && err.body.message)
    || (err && err.message)
    || ""
  ).toLowerCase()
  return status === 405 || message.includes("not allowed") || message.includes("method")
}

export default {
  authenticate({ email, password }) {
    return AuthResource.save({}, { email, password });
  },
  mySelf() {
    return MySelfResource.get();
  },
  createSupportSession({ userId, application }) {
    return SupportSessionCreateResource.save({}, { userId, application });
  },
  exchangeSupportSession({ code, application }) {
    return SupportSessionExchangeResource.save({}, { code, application });
  },
  endSupportSession() {
    return SupportSessionEndResource.delete({}, {});
  },
  getSyncRevisions() {
    return SyncRevisionsResource.get();
  },
  signUp({ email, password, displayname, dsgvo }) {
    return SignUpResource.save({}, { email, password, displayname, dsgvo });
  },
  activateAccount({ token }) {
    return ActivateAccountResource.get({ token }, {});
  },
  forgotPassword({ email }) {
    return ForgotPasswordResource.save({ email });
  },
  resetPassword(obj) {
    return ResetPasswordResource.save({}, obj);
  },
  getDevices({ type } = {}) {
    return DeviceResource.get({ type });
  },
  getDevicesOnly({ type, scope } = {}) {
    return DeviceOnlyResource.get({ type, scope });
  },
  getDevice(device) {
    return DeviceGetResource.get(device);
  },
  getDeviceDebugValues(device) {
    return DeviceGetDebugValuesResource.get(device);
  },
  getMqttBrokerAccessOverview(params = {}) {
    return MQTTbrokerAccessOverviewResource.get(params);
  },
  getMqttBrokerAccess(deviceId) {
    return MQTTbrokerAccessDeviceResource.get({ id: deviceId });
  },
  syncHeatcontrolSubAccess(deviceId) {
    return Vue.http.post(`${API_ROOT}mqtt/heatcontrol-sub-access/${deviceId}`, {});
  },
  prepareFirmwareFlash(payload) {
    return Vue.http.post(`${API_ROOT}mqtt/firmware-prepare`, payload);
  },
  startArtifactTransfer(deviceId, payload) {
    return Vue.http.post(`${API_ROOT}devices/${deviceId}/artifact-transfer`, payload);
  },
  getFirmwareElf(hash) {
    return Vue.http.get(`${API_ROOT}mqtt/firmware-elf/${hash}`, { responseType: "blob" });
  },
  getFirmwareChecksum(filename) {
    return MQTTfirmwareChecksumResource.get({ filename });
  },
  getMqttPermissionRequests(params = {}) {
    return MQTTPermissionRequestResource.get(params);
  },
  getMqttClaimRequests(params = {}) {
    return MQTTClaimRequestResource.get(params);
  },
  approveMqttPermissionRequest(id, payload = {}) {
    return MQTTPermissionRequestActionResource.save({ id, action: "approve" }, payload);
  },
  cleanupDeviceForeignMqttAccess(deviceId, payload = {}) {
    return MQTTPermissionDeviceActionResource.save({ id: deviceId, action: "cleanup-once" }, payload);
  },
  approveMqttClaimRequest(id, payload = {}) {
    return MQTTClaimRequestActionResource.save({ id, action: "approve" }, payload);
  },
  rejectMqttPermissionRequest(id, payload = {}) {
    return MQTTPermissionRequestActionResource.save({ id, action: "reject" }, payload);
  },
  rejectMqttClaimRequest(id, payload = {}) {
    return MQTTClaimRequestActionResource.save({ id, action: "reject" }, payload);
  },
  revokeMqttPermissionRequest(id, payload = {}) {
    return MQTTPermissionRequestActionResource.save({ id, action: "revoke" }, payload);
  },
  deleteAllDeviceForeignMqttAccess(deviceId, payload = {}) {
    return MQTTPermissionDeviceActionResource.save({ id: deviceId, action: "delete-all" }, payload);
  },
  blockMqttClaimRequest(id, payload = {}) {
    return MQTTClaimRequestActionResource.save({ id, action: "block" }, payload);
  },
  triggerRescueOta(deviceId, payload) {
    return MQTTrescueOtaResource.save({ id: deviceId }, payload);
  },
  triggerOtaNextion(deviceId, payload) {
    return MQTTotaNextionResource.save({ id: deviceId }, payload);
  },
  triggerRescueProvision(deviceId, payload = {}) {
    return MQTTrescueProvisionResource.save({ id: deviceId }, payload);
  },
  getDevicesAll() {
    return DeviceAllResource.get();
  },
  getSuspiciousDeviceAnalysis() {
    return DeviceSuspiciousAnalysisResource.get();
  },
  getSuspiciousDeviceEvents(id, limit = 50) {
    return DeviceSuspiciousEventsResource.get({ id, limit });
  },
  getDeviceTestResetPreview(id) {
    return DeviceTestResetPreviewResource.get({ id });
  },
  executeDeviceTestReset(id, payload) {
    return DeviceTestResetExecuteResource.save({ id }, payload);
  },
  updateDeviceLocation(deviceLocation) {
    return DeviceLocationUpdateResource.update({id: deviceLocation.deviceId} , deviceLocation);
  },
  activateDeviceDryRun(deviceId) {
    return DeviceActivateDryRunResource.save({ id: deviceId }, {});
  },
  migrateDeviceMqtt(deviceId) {
    return DeviceMigrateResource.save({ id: deviceId }, {});
  },
  prepareDeviceDirectMqtt(deviceId) {
    return DevicePrepareDirectMqttResource.save({ id: deviceId }, {});
  },
  updateDeviceConfig(item) {
    const id = item.id
    return DeviceConfigUpdateResource.update({id}, item.config);
  },
  updateSolartrackerCanDisplay(id, profiles) {
    return SolartrackerCanDisplayResource.update({ id }, { profiles });
  },
  updateDeviceMetadata(id, metadata) {
    return DeviceUpdateResource.update({ id }, metadata);
  },
  getDeviceSetreducedCommandOptions(id) {
    return DeviceSetreducedCommandsResource.get({ id });
  },
  updateDeviceSetreducedCommands(id, commands) {
    return DeviceSetreducedCommandsResource.update({ id }, { commands });
  },
  deleteDevice(id, payload = {}) {
    return DeviceDeleteResource.delete({ id, mode: payload.mode || "delete" }, payload);
  },
  getDeviceEvents(obj) {  //{ deviceId, days, startDate, endDate }
    // console.log("getDeviceEvents", obj)
    return DeviceEventResource.get(obj);
  },
  getLocationEventsIndex(obj) {
    return LocationEventIndexResource.get(obj);
  },
  /* setHT({ device, HT }) {
    return MQTTSetHTResource.save({}, { device, HT });
  },
  setNT({ device, NT }) {
    return MQTTSetNTResource.save({}, { device, NT });
  },
  allAwake() {
    return MQTTallAwakeResource.save({}, {});
  },*/
  getDeviceConsole(id, query = {}) {
    return MQTTdeviceConsoleResource.get({ id, ...query });
  },
  closeDeviceConsoleStream(streamId) {
    return MQTTdeviceConsoleStreamCloseResource.save({}, { streamId });
  },
  setDevice(obj) {
    return MQTTsetDeviceResource.save({}, obj);
  },
  getGatewayConfig(id) { return GatewayConfigurationResource.get({ id }); },
  updateGatewayConfig(id, payload) { return GatewayConfigurationResource.update({ id }, payload); },
  retryGatewayConfig(id) { return GatewayRetryResource.save({ id }, {}); },
  getRelayBoardConfig(id) { return RelayBoardConfigurationResource.get({ id }); },
  updateRelayBoardConfig(id, payload) { return RelayBoardConfigurationResource.update({ id }, payload); },
  readModbusGatewayConfig(id) {
    return ModbusGatewayConfigReadResource.save({ id }, {});
  },
  updateModbusGatewayConfig(id, config) {
    return ModbusGatewayConfigResource.update({ id }, config);
  },
  transactModbusGateway(id, transaction) {
    return ModbusGatewayTransactionResource.save({ id }, transaction);
  },
  allResetLocation() {
    return EventallResetLocationResource.save({}, {});
  },
  createPerson(person) {
    return CreatePersonResource.save({},person);
  },
  getPersons() {
    return PersonResource.get();
  },
  getPersonHistory(id) {
    return PersonHistoryResource.get({ id }, {});
  },
  deletePerson(id) {
    return PersonDeleteResource.delete({ id }, {});
  },
  deactivatePerson(id) {
    return PersonDeactivateResource.update({ id }, {});
  },
  updatePerson(person) {
    return PersonUpdateResource.update({ id: person._id }, person);
  },
  getLocation() {
    return LocationResource.get();
  },
  createLocation(location) {
    return LocationCreateResource.save({}, location);
  },
  updateLocation(location) {
    return LocationUpdateResource.update({ id: location._id }, location);
  },
  deleteLocation(id) {
    return LocationDeleteResource.delete({ id }, {});
  },
  revealLocationSecret(id) {
    return LocationSecretRevealResource.save({ id }, {});
  },
  setLocationSecret(id, payload) {
    return LocationSecretSetResource.save({ id }, payload);
  },
  previewHeatcontrolMulti(payload) {
    return HeatcontrolMultiPreviewResource.save({}, payload);
  },
  getHeatcontrolApartmentSupply(apartments) {
    return HeatcontrolApartmentSupplyResource.get({ apartments: apartments.join(',') });
  },
  getHeatcontrolApartmentConsumption(apartmentId, from, to) {
    return HeatcontrolApartmentConsumptionResource.get({ apartmentId, from, to });
  },
  getHeatcontrolApartmentDevice(apartmentId) { return HeatcontrolApartmentDeviceResource.get({ apartmentId }); },
  getHeatcontrolTemperatureControl(apartmentId) { return HeatcontrolTemperatureControlResource.get({ apartmentId }); },
  setHeatcontrolTemperatureControl(apartmentId, payload) { return HeatcontrolTemperatureControlResource.update({ apartmentId }, payload); },
  commitHeatcontrolMulti(payload) {
    return HeatcontrolMultiCommitResource.save({}, payload);
  },
  activateHeatcontrolMulti(configurations, options = {}) {
    return HeatcontrolMultiActivateResource.save({}, { configurations, localTest: options.localTest });
  },
  getHeatcontrolAreaBindings(deviceId) {
    return HeatcontrolAreaBindingsResource.get({ deviceId });
  },
  getHeatcontrolMulti(deviceId) {
    return HeatcontrolMultiResource.get({ deviceId });
  },
  getHeatcontrolMultiDiagnostics(deviceId) {
    return HeatcontrolMultiDiagnosticsResource.get({ deviceId });
  },
  setHeatcontrolLocalTest(deviceId, enabled) {
    return HeatcontrolLocalTestResource.save({ deviceId }, { enabled });
  },
  stageHeatcontrolMulti(deviceId, version, options = {}) {
    return HeatcontrolMultiStageResource.save({ deviceId, version }, { localTest: options.localTest, reliable: options.reliable });
  },
  cancelHeatcontrolTransfer(deviceId, version) {
    return HeatcontrolTransferCancelResource.save({ deviceId, version }, {});
  },
  rollbackHeatcontrolMulti(deviceId) {
    return HeatcontrolMultiRollbackResource.save({ deviceId }, {});
  },
  readUser({id}){
    return UserReadResource.get({id}, {});
  },
  getUser(){
    return UserResource.get();
  },
  createUser(user) {
    return UserCreateResource.save({}, user);
  },
  updateUser(user) {
    return UserUpdateResource.update({ id: user._id }, user);
  },
  updateDashboardSettings(settings) {
    return UserUpdateDashboardSettingsResource.update(settings);
  },
  createEnergyUnit(energyunit) {
    return CreateEnergyUnitResource.save({},energyunit);
  },
  getEnergyUnit() {
    return EnergyUnitResource.get();
  },
  getEnergyUnitHistory(id) {
    return EnergyUnitHistoryResource.get({ id }, {});
  },
  deleteEnergyUnit(id) {
    return EnergyUnitDeleteResource.delete({ id }, {});
  },
  deactivateEnergyUnit(id) {
    return EnergyUnitDeactivateResource.update({ id }, {});
  },
  updateEnergyUnit(energyunit) {
    return EnergyUnitUpdateResource.update({ id: energyunit._id }, energyunit);
  },
  getGlobal() {
    return GlobalResource.get();
  },
  getGlobalAll() {
    return GlobalAllResource.get();
  },
  getUnusedGlobals() {
    return GlobalUnusedResource.get();
  },
  createGlobal(item) {
    return GlobalCreateResource.save({}, item )
  },
  updateGlobal(item) {
    return GlobalUpdateResource.update({ id: item._id }, item);
  },
  deleteGlobal(id) {
    return GlobalDeleteResource.delete({ id });
  },
  getPriceIndex() {
    return PriceIndexResource.get();
  },
  createPriceIndex(price_index) {
    return CreatePriceIndexResource.save({},price_index)
  },
  updatePriceIndex(price_index) {
    return PriceIndexUpdateResource.update({ id: price_index._id }, price_index);
  },
  createContract(contract) {
    return CreateContractResource.save({},contract);
  },
  getContract() {
    return ContractResource.get();
  },
  getContractHistory(id) {
    return ContractHistoryResource.get({ id }, {});
  },
  deleteContract(id) {
    return ContractDeleteResource.delete({ id }, {});
  },
  deactivateContract(id) {
    return ContractDeactivateResource.update({ id }, {});
  },
  updateContract(contract) {
    return ContractUpdateResource.update({ id: contract._id }, contract);
  },
  getInvoice(id) {
    return InvoiceResource.get({ id }, {});
  },
  createInvoiceProvider(val) {
    return InvoiceCreateProviderResource.save({"id": val.id}, {billing_period: val.billing_period});
  },
  deleteInvoice(id, param) {
    return InvoiceDeleteResource.delete({id}, {param});
  },
  getInvoiceProvider(id) {
    return InvoiceProviderResource.get(id, {});
  },
  sendInvoiceProviderAll(id) {
    return InvoiceSendProviderAllResource.save({id}, {});
  },
  sendInvoice(id) {
    return InvoiceSendResource.save({id}, {});
  },
  getDeviceSetting() {
    return DeviceSettingResource.get();
  },
  createDeviceSetting(item) {
    return DeviceSettingCreateResource.save({}, item )
  },
  updateDeviceSetting(item) {
    return DeviceSettingUpdateResource.update({ id: item._id }, item);
  },
  getDeviceIFrame(id) {
    return DeviceGetIFrameResource.get(id, {});
  },
  getLocationRawEventsIndex(obj) {
    return LocationRawEventIndexResource.get(obj);
  },
  getLocationPVForeCast(obj) {
    //console.log({ location, time })
    return LocationPVForeCastResource.save(obj);
  },
  getFcSolarHa(obj) {
    //console.log({ location, time })
    return HaSolarForeCastResource.save(obj);
  },
  getMixPrice(obj) {
    // console.log(obj)
    return MixPriceForeCastResource.save(obj);
  },
  getMpcControlHistory(obj) {
    return MpcControlHistoryResource.save(obj);
  },
  getMpcCostOverview(obj) {
    return MpcCostOverviewResource.save(obj);
  },
  getObsDataset(obj) {
    return ObsDatasetResource.get(obj);
  },
  getAlerts() {
    return AlertResource.get();
  },
  deleteAlert(id) {
    return AlertDeleteResource.delete({ id }, {});
  },
  getVapidPublicKey() {
    return VapidPublicKeyResource.get();
  },
  subscribePush(subscription) {
    return PushSubscriptionResource.save({}, subscription);
  },
  unsubscribePush(subscription) {
    return PushUnsubscribeResource.save({}, subscription);
  },
  // Icons API
  getIcons() {
    return IconResource.get();
  },
  createIcon(icon) {
    return IconCreateResource.save({}, icon);
  },
  updateIcon(icon) {
    return IconUpdateResource.update({ id: icon._id }, icon);
  },
  deleteIcon(id) {
    return IconDeleteResource.delete({ id }, {});
  },
  // Inverter control API
  getInverterParams(id) {
    return InverterParamsResource.get({ id });
  },
  controlInverter({ id, params }) {
    return InverterControlResource.save({ id }, { params });
  },
  // Agent API

  getLlmConnections() {
    return AgentConnectionsResource.get();
  },
  getLlmConnection({ id }) {
    return AgentConnectionResource.get({ id });
  },
  createLlmConnection(connection) {
    return AgentConnectionsResource.save({}, connection);
  },
  updateLlmConnection(connection) {
    return AgentConnectionResource.update({ id: connection._id }, connection);
  },
  deleteLlmConnection(id) {
    return AgentConnectionResource.delete({ id }, {});
  },
  testLlmConnection({ id }) {
    return AgentConnectionTestResource.save({ id }, {});
  },
  testLlmVision({ id }) {
    return AgentConnectionVisionTestResource.save({ id }, {});
  },
  setActiveLlmConnection({ id }) {
    return AgentConnectionSetActiveResource.save({ id }, {});
  },
  getPlanImportSessions(includeArchived = false) {
    return PlanImportSessionsResource.get(includeArchived ? { includeArchived: true } : {});
  },
  createPlanImportSession(payload) {
    return PlanImportSessionsResource.save({}, payload || {});
  },
  exportPlanImportPackage(id) {
    return PlanImportPackageExportResource.get({ id });
  },
  importPlanImportPackage(payload) {
    return PlanImportPackageImportResource.save({}, payload || {});
  },
  getPlanImportSession(id) {
    return PlanImportSessionResource.get({ id });
  },
  updatePlanImportSession(id, payload) {
    return PlanImportSessionResource.update({ id }, payload || {});
  },
  importSpatialWindows(id, payload) {
    return Vue.http.post(`${API_ROOT}plan-import/sessions/${encodeURIComponent(id)}/spatial-windows`, payload || {});
  },
  getSpatialPlanImportPrompt() {
    return Vue.http.get(`${API_ROOT}plan-import/spatial/prompt`);
  },
  deletePlanImportSession(id, confirmation) {
    return Vue.http.delete(`${API_ROOT}plan-import/sessions/${encodeURIComponent(id)}`, { body: { confirmation } });
  },
  setPlanImportSessionArchived(id, archived) {
    return PlanImportSessionArchiveResource.update({ id }, { archived: archived === true });
  },
  uploadPlanImportFile(id, file) {
    return Vue.http.post(`${API_ROOT}plan-import/sessions/${encodeURIComponent(id)}/files`, file, {
      headers: {
        "Content-Type": file.type || "application/octet-stream",
        "X-File-Name": encodeURIComponent(file.name || "plan")
      }
    });
  },
  deletePlanImportFile(id, fileId) {
    return PlanImportFileResource.delete({ id, fileId }, {});
  },
  getPlanImportFilePreview(id, fileId, page = 1, rotation = 0, maxPixels = 2200, crop = null) {
    const query = new URLSearchParams({ page: String(page), rotation: String(rotation), maxPixels: String(maxPixels) });
    if (crop) {
      query.set("cropX", String(crop.x)); query.set("cropY", String(crop.y));
      query.set("cropWidth", String(crop.width)); query.set("cropHeight", String(crop.height));
    }
    const supportToken = sessionStorage.getItem("SupportAuthorization");
    const isSupportWindow = sessionStorage.getItem("SupportWindow") === "1";
    const token = supportToken || (isSupportWindow ? null : localStorage.getItem("Authorization"));
    const headers = { Accept: "application/octet-stream" };
    if (token) headers.Authorization = token;
    return fetch(`${API_ROOT}plan-import/sessions/${encodeURIComponent(id)}/files/${encodeURIComponent(fileId)}/preview?${query}`, {
      method: "GET",
      headers,
      cache: "no-store"
    }).then(async response => {
      if (response.ok) return response.blob();
      let message = `Planvorschau konnte nicht geladen werden (${response.status}).`;
      try {
        const body = await response.json();
        message = body.message || body.error || message;
      } catch (_) { /* binary/text error response */ }
      throw new Error(message);
    });
  },
  approvePlanImportExternal(id, approved) {
    return PlanImportExternalResource.save({ id }, { approved: approved === true });
  },
  analyzePlanImport(id, payload = {}) {
    return PlanImportAnalyzeResource.save({ id }, payload);
  },
  getPlanImportManualPrompt(id, includeWindows = true) {
    return Vue.http.get(`${API_ROOT}plan-import/sessions/${encodeURIComponent(id)}/manual-prompt?includeWindows=${includeWindows ? "true" : "false"}`);
  },
  importPlanImportManualAnalysis(id, payload) {
    return PlanImportManualAnalysisResource.save({ id }, payload);
  },
  reanalyzePlanImportPage(id, payload = {}) {
    return PlanImportReanalyzeResource.save({ id }, payload);
  },
  chatPlanImport(id, message) {
    return PlanImportChatResource.save({ id }, { message });
  },
  applyPlanImportPatch(id, payload) {
    return PlanImportPatchResource.save({ id }, payload);
  },
  undoPlanImportPatch(id, payload) {
    return PlanImportPatchUndoResource.save({ id }, payload);
  },
  getPlanImportJobs(id) {
    return PlanImportJobsResource.get({ id });
  },
  cancelPlanImportJob(id, jobId) {
    return PlanImportJobCancelResource.save({ id, jobId }, {});
  },
  previewPlanImport(id) {
    return PlanImportPreviewResource.get({ id });
  },
  commitPlanImport(id, confirmation) {
    return PlanImportCommitResource.save({ id }, { confirmation });
  },
  previewPlanImportRollback(id, action = "deactivate", force = false) {
    return PlanImportRollbackPreviewResource.get({ id, action, force });
  },
  rollbackPlanImport(id, token, confirmation, action = "deactivate", force = false) {
    return PlanImportRollbackResource.save({ id }, { token, confirmation, action, force });
  },
  reopenPlanImport(id, version) {
    return PlanImportReopenResource.save({ id }, { version });
  },
  getPlanImportThermalProfiles() {
    return PlanImportThermalProfilesResource.get();
  },
  getPlanImportGoogleContext(payload) {
    return PlanImportGoogleContextResource.save({}, payload || {});
  },
  searchPlanImportAddress(address) {
    return PlanImportAddressSearchResource.save({}, { address });
  },
  getPlanImportObstacleHeight(payload) {
    return PlanImportObstacleHeightResource.save({}, payload || {});
  },
  getPlanImportSunPath(payload) {
    return PlanImportSunPathResource.save({}, payload || {});
  },
  getPlanImportProcessProfile() {
    return PlanImportProcessProfileResource.get();
  },
  updatePlanImportProcessProfile(payload) {
    return PlanImportProcessProfileResource.update({}, payload || {});
  },
  getElasticConnections() {
    return ElasticConnectionsResource.get();
  },
  getElasticConnection({ id }) {
    return ElasticConnectionResource.get({ id });
  },
  createElasticConnection(connection) {
    return ElasticConnectionsResource.save({}, connection);
  },
  updateElasticConnection(connection) {
    return ElasticConnectionResource.update({ id: connection._id }, connection);
  },
  deleteElasticConnection(id) {
    return ElasticConnectionResource.delete({ id }, {});
  },
  testElasticConnection({ id }) {
    return ElasticConnectionTestResource.save({ id }, {});
  },
  setActiveElasticConnection({ id }) {
    return ElasticConnectionSetActiveResource.save({ id }, {});
  },

};
